export default __webpack_public_path__ + "static/media/jul4.29a146d0.jpg";